module.exports = __webpack_public_path__ + "static/media/a20.ffd12dd5.pdf";